'use es6';

import { fromJS } from 'immutable';
import { findIndex } from 'underscore';
import { cmv2FontConverter, generateFontFieldValue } from 'EmailEditorUI/utils/fieldUtils';
import { getFontOptionsForCmv2 } from 'EmailEditorUI/constants/TemplateSettingsConstants';
import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import produce from 'immer';
import get from 'hs-lodash/get';
import set from 'hs-lodash/set';
export const convertUserModuleDefaults = userDefaults => {
  const newFontStyle = userDefaults.getIn(['button_email', 'font_style']);
  if (userDefaults.get('button_email') && (!newFontStyle || newFontStyle.size === 0)) {
    return userDefaults.setIn(['button_email', 'font_style'], fromJS(generateFontFieldValue({
      font: userDefaults.getIn(['button_email', 'font']),
      color: userDefaults.getIn(['button_email', 'font_color']),
      fontSize: userDefaults.getIn(['button_email', 'font_size'])
    })));
  }
  return userDefaults;
};
export const convertUserModuleDefaultsImmer = userDefaults => {
  var _userDefaults$button_;
  const newFontStyle = (_userDefaults$button_ = userDefaults.button_email) === null || _userDefaults$button_ === void 0 ? void 0 : _userDefaults$button_.font_style;
  if (userDefaults.button_email && (!newFontStyle || newFontStyle.length === 0)) {
    return produce(userDefaults, draft => {
      set(draft, ['button_email', 'font_style'], generateFontFieldValue({
        font: get(draft, ['button_email', 'font']),
        color: get(draft, ['button_email', 'font_color']),
        fontSize: get(draft, ['button_email', 'font_size'])
      }));
    });
  }
  return userDefaults;
};
export const convertStyleSettings = (styleSettings, webfonts) => {
  if (styleSettings.primary_font) {
    styleSettings.primary_font = cmv2FontConverter(styleSettings.primary_font, webfonts);
  }
  if (styleSettings.heading_one_font && styleSettings.heading_one_font.font) {
    styleSettings.heading_one_font.font = cmv2FontConverter(styleSettings.heading_one_font.font, webfonts);
  }
  return styleSettings;
};
function moduleHasFontFields(customModule) {
  return (customModule.fields || []).find(f => f.type === FieldTypes.FONT || f.name === 'font' || f.children != null && (f.children || []).some(c => c.type === FieldTypes.FONT));
}
function convertFontFields(fields, webfonts) {
  if (!fields || !fields.length) {
    return fields;
  }
  return fields.map(field => {
    if (field.children && field.children.length) {
      return Object.assign({}, field, {
        children: convertFontFields(field.children, webfonts)
      });
    }
    if (field.type !== FieldTypes.FONT) {
      return field;
    }
    return Object.assign({}, field, {
      default: Object.assign({}, field.default, {
        font: cmv2FontConverter(field.default.font, webfonts)
      })
    });
  });
}
export const convertCustomModuleSpec = (customModuleSpec, webfonts = [], isDefaultModule) => {
  if (!moduleHasFontFields(customModuleSpec)) {
    return customModuleSpec;
  }
  let clonedSpec = Object.assign({}, customModuleSpec);
  if (isDefaultModule) {
    const {
      fields
    } = clonedSpec;
    const fontFieldIndex = findIndex(fields, field => field.name === 'font' && field.type !== FieldTypes.FONT);
    if (fontFieldIndex > -1) {
      const fontField = clonedSpec.fields[fontFieldIndex];
      const newChoices = [...getFontOptionsForCmv2(), ...webfonts];
      const newFontField = Object.assign({}, fontField, {
        choices: newChoices,
        default: cmv2FontConverter(fontField.default, webfonts)
      });
      const newFields = Array.from(fields);
      newFields[fontFieldIndex] = newFontField;
      clonedSpec = Object.assign({}, clonedSpec, {
        fields: newFields
      });
    }
  }
  clonedSpec = Object.assign({}, clonedSpec, {
    fields: convertFontFields(clonedSpec.fields, webfonts)
  });
  return clonedSpec;
};